import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const lmsRoutes = [
	{
		key: "lms-category-tree",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/category-tree`,
		component: React.lazy(() => import("views/app-views/lms/category_tree/pages/CategoryTree")),
	},
	{
		key: "lms-categories",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/categories`,
		component: React.lazy(() => import("views/app-views/lms/category_tree/pages/CategoryTree")),
	},
	{
		key: "lms-skills",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/skills`,
		component: React.lazy(() => import("views/app-views/lms/skills/pages/Skills")),
	},
	{
		key: "lms-media",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/media`,
		component: React.lazy(() => import("views/app-views/lms/media/pages/MediaList")),
	},
	{
		key: "lms-courses-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/courses`,
		component: React.lazy(() => import("views/app-views/lms/courses/pages/CoursesList")),
	},
	{
		key: "lms-courses-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/courses/create`,
		component: React.lazy(() => import("views/app-views/lms/courses/pages/CourseCreate")),
	},
	{
		key: "lms-courses-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/courses/edit/:id`,
		component: React.lazy(() => import("views/app-views/lms/courses/pages/CourseCreate")),
	},
	{
		key: "lms-courses-view",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/courses/view/:id`,
		component: React.lazy(() => import("views/app-views/lms/courses/pages/CourseView")),
	},
	{
		key: "lms-course-assignment",
		exact: true,
		path: `${APP_PREFIX_PATH}/lms/course-assignment`,
		component: React.lazy(() => import("views/app-views/lms/course-assignment/pages/CourseAssignment")),
	},
];
